export const MINUTE_NUMBER = 1000 * 60;
export const HOUR_NUMBER = MINUTE_NUMBER * 60;
export const ONE_DAY = HOUR_NUMBER * 24;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_YEAR = ONE_DAY * 365;